import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { useState } from "react";

const SendGroupedEmailModal = ({
  onClose,
  groupEmailEntities,
  hierarchyEmailAddresses,
}) => {
  const [isSelectionCopied, setIsSelectionCopied] = useState(false);
  const intl = useIntl();
  const isSendAll = groupEmailEntities?.length > 1;
  const handleCopySelectionBtn = (emailList) =>
    navigator.clipboard.writeText(emailList);

  return (
    <>
      <div className="overlay-style" />
      <div className="validation-modal-style grouped-email-modal">
        <div className="header">
          <Icon color="gray-200" icon="close" onClick={onClose} />
        </div>
        <div className="body">
          <div className="title">
            {" "}
            <Icon
              color="violet"
              icon="email"
              width={25}
              height={25}
              marginRight={10}
            />
            {intl
              .formatMessage({
                id: "send_group_email",
                defaultMessage: "Envoyer un mail groupé",
              })
              .toUpperCase()}
            {groupEmailEntities[0] &&
              ` ${
                " : " +
                intl
                  .formatMessage({
                    id: isSendAll ? "all" : groupEmailEntities[0],
                    defaultMessage: isSendAll ? "tous" : groupEmailEntities[0],
                  })
                  .toUpperCase()
              }${isSendAll ? "" : "S"}`}
          </div>
          <div className="description violet">
            <FormattedMessage
              id="group_email_modal_description"
              defaultMessage="Votre groupe est trop important pour lancer le mailer, merci de faire CTRL + V dans votre barre d'adresse"
            />
          </div>
          <div className="email-addresses-list">
            {hierarchyEmailAddresses?.emails}
          </div>
          <div className="copy-selection-btn">
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={() => {
                handleCopySelectionBtn(hierarchyEmailAddresses?.emails);
                setIsSelectionCopied(true);
              }}
            >
              <FormattedMessage
                id={isSelectionCopied ? "selection_copied" : "copy_selection"}
                defaultMessage={
                  isSelectionCopied
                    ? "Séléction copiée !"
                    : "Copier la séléction"
                }
              />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendGroupedEmailModal;

SendGroupedEmailModal.propTypes = {
  onClose: PropTypes.func,
  groupEmailEntities: PropTypes.object,
  hierarchyEmailAddresses: PropTypes.object,
};
